import { useGlobal } from '../hooks';
import { ReviewTotalBox, mqUp } from 'rwl-ui';
import styled from '@emotion/styled';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--rwl-spacing-sm);
    cursor: pointer;

    ${mqUp('xs')} {
        margin-left: var(--rwl-spacing-md);
    }
`;

export const ReviewTotals = () => {
    const { config } = useGlobal();

    if (
        !config?.extraData?.integrations ||
        config.extraData.integrations.length === 0
    ) {
        return <div />;
    }

    return (
        <Container>
            {config.extraData.integrations.map((integration) => (
                <ReviewTotalBox
                    style={{
                        border: '1px solid var(--rwl-color-neutral-border)',
                        borderRadius: 'var(--rwl-radius-xs)',
                        boxShadow: '0px 1px 8px 0px rgba(0, 0, 0, 0.12)',
                        padding:
                            'calc(var(--rwl-spacing-sm) * 0.75) var(--rwl-spacing-sm)',
                    }}
                    onClick={() => window.open(integration.url, '_blank')}
                    key={integration.type}
                    count={integration.reviewCount}
                    rating={integration.reviewRating}
                    source={
                        integration.type === 'Google' ? 'GMB' : integration.type
                    }
                    breakpoint={'md'}
                />
            ))}
        </Container>
    );
};
